import React from "react";
import { Box, IconButton, Typography, alpha } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReplyIcon from "@mui/icons-material/Reply";
import { useTranslation } from "react-i18next";
import { teamMessageSnippet } from "../utils/teamMessageUtils";

const TeamComposerReplyBar = ({ replyTo, onClear }) => {
  const { t } = useTranslation("team");
  if (!replyTo) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 0.75,
        mb: 0.75,
        borderRadius: 1.5,
        borderLeft: 3,
        borderColor: "primary.main",
        bgcolor: (th) => alpha(th.palette.primary.main, 0.06),
      }}
    >
      <ReplyIcon fontSize="small" color="primary" />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="caption" fontWeight={700} color="primary.main" display="block">
          {t("replyingTo", { name: replyTo.authorName || t("unknownAuthor") })}
        </Typography>
        <Typography variant="caption" color="text.secondary" noWrap display="block">
          {teamMessageSnippet(replyTo, { t })}
        </Typography>
      </Box>
      <IconButton size="small" onClick={onClear} aria-label={t("cancelReply")}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default TeamComposerReplyBar;
